import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useUnLinkInvoice = (invoiceId: string, receiptId: string) => {
  const call = useCallback(async () => {
    try {
      await axiosInstance.put(api.unlinkInvoice(receiptId), undefined, {
        params: { invoiceId },
      });
    } catch (error) {
      throw new Error(error);
    }
  }, [invoiceId, receiptId]);

  const { isLoading, execute } = useAsync(call, false);

  return { isLoading, unlinkInvoice: execute };
};

export default useUnLinkInvoice;
